/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRightDown: {
  name: 'arrow-right-down';
  data: string;
} = {
  name: 'arrow-right-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.293 6.293a1 1 0 0 1 1.414 0L16 14.586V9a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2h5.586L6.293 7.707a1 1 0 0 1 0-1.414Z" fill="currentColor"/></svg>`,
};
